import React from 'react';
import '@react-pdf-viewer/core/lib/styles/index.css';
import "./pdfViewer.scss"

const PdfViewer = ({ pdfUrls }) => {
  return (
    <div className='pdf_viewer'>
      Pdf downloaded successfully !
    <iframe title="PDF Viewer" src={pdfUrls} width="100%" height="500px" />
    </div>
  );
};

export default PdfViewer;
